import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Grid, Stack, styled, Typography } from '@mui/material';

import { useDispatch, useSelector } from '../../redux/store';
import { openLoginSignup } from '../../redux/slices/authPages';

import Page from '../../components/Page';
import Image from '../../components/Image';
import BannerCarousel from './BannerCarousel';
import { getPromotions, getFakePlayerStats } from '../../redux/slices/lookup';
import CustomModal from '../../components/CustomModal';
import { isHTML, sanitizeHtml } from '../../utils/formatString';
import useLocales from '../../hooks/useLocales';
import palette from '../../theme/palette';
import PopupBanner from '../../layouts/dashboard/PopupBanner';
import { closeLoadingScreen, openLoadingScreen } from '../../redux/slices/settings';
import { AuthButtons } from '../../layouts/GlobalStyles';
import useAuth from '../../hooks/useAuth';
import HomeNavRow from './HomeNavRow';
import HomeNavCol from './HomeNavCol';
import { HEADER } from '../../config';

const HomeLayout = () => {
  const navigate = useNavigate();

  const { isAuthenticated } = useAuth();

  const { translate } = useLocales();

  const location = useLocation();

  const { siteSettings, promotions } = useSelector((x) => x.lookup);

  const { activeTab } = useSelector((x) => x.game);

  const dispatch = useDispatch();

  const [allGames, setAllGames] = useState([]);

  const [openPromotion, setOpenPromotion] = useState(null);

  const [count, setCount] = useState(0);

  const [running, setRunning] = useState(true);

  const refDepositBonusId = useMemo(() => {
    const bonuses = promotions?.data?.filter((f) => f.promotion_type === 'referral_deposit_bonus');

    if (bonuses?.length) {
      return bonuses[0]?.id;
    }

    return null;
  }, [promotions]);

  useEffect(() => {
    dispatch(openLoadingScreen());
    Promise.all([getPromotions(), getFakePlayerStats()]).finally(() => dispatch(closeLoadingScreen()));
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (running) {
        setCount(count + 1);
        getFakePlayerStats();
      }
    }, 90000);

    return () => clearTimeout(timer);
  }, [count, running]);

  useEffect(() => {
    const scrollEl = document.getElementById('mainBody');
    if (scrollEl && location.pathname === '/promotion') {
      scrollEl.scrollIntoView();
    }

    // handleResetLoadMore();
  }, [location.pathname]);

  //   useEffect(() => {
  //     if (!localStorage.getItem('accessToken')) {
  //       if (popupAuth === '1') dispatch(openLoginSignup({ open: true, isLogin: true }));
  //       if (popupAuth === '2') dispatch(openLoginSignup({ open: true, isLogin: false }));
  //     }
  //   }, [popupAuth]);

  //   const handleResetLoadMore = () => {
  //     if (allGames.filter((f) => f.showCount > 12).length > 0) {
  //       setAllGames([...allGames.map((item) => ({ ...item, showCount: 12, currentPage: 1 }))]);
  //     }
  //   };

  return (
    <Page title="Home" sx={{ position: 'relative' }}>
      <Box sx={{ width: '100%', px: { sm: 2, xs: 0 }, pb: 2 }}>
        <BannerCarousel />

        <Container
          maxWidth="lg"
          sx={{
            px: { sm: '16px !important', xs: '8px !important' },
          }}
        >
          {!isAuthenticated ? (
            <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
              <Box sx={{ width: '50%' }}>
                <AuthButtons fullWidth onClick={() => navigate('/auth/register')}>
                  {translate('register')}
                </AuthButtons>
              </Box>
              <Box sx={{ width: '50%' }}>
                <AuthButtons fullWidth onClick={() => dispatch(openLoginSignup({ open: true, isLogin: true }))}>
                  {translate('login')}
                </AuthButtons>
              </Box>
            </Box>
          ) : (
            ''
          )}

          <Box>
            {siteSettings?.announcement_text?.WalkPromotion?.content && (
              <Stack
                direction="row"
                alignItems={'center'}
                sx={{
                  p: '0px 8px',
                  mt: 1,
                  background: palette.home.announcement.bg,
                  borderRadius: 0.5,
                  cursor: siteSettings?.announcement_text?.WalkPromotion?.url ? 'pointer' : 'none',
                }}
                onClick={() => {
                  if (siteSettings?.announcement_text?.WalkPromotion?.url) {
                    window.open(siteSettings?.announcement_text?.WalkPromotion?.url, '_blank');
                  }
                }}
              >
                <Image src={require('../../assets/home/bell.png')} sx={{ height: '32px', width: '35px' }} />
                <Box className="marquee" sx={{ width: '100%' }}>
                  <Typography sx={{ color: palette.home.announcement.color, fontWeight: 400, fontSize: '0.8rem' }}>
                    {siteSettings?.announcement_text?.WalkPromotion?.content}
                  </Typography>
                </Box>
              </Stack>
            )}
          </Box>

          <Box sx={{ my: 2, scrollMarginTop: HEADER.MOBILE_HEIGHT }} id={'mainBody'}>
            <HomeNavRow />
          </Box>

          <Grid container>
            <Grid item xs={3} lg={1}>
              <HomeNavCol />
            </Grid>
            <Grid item xs={9} lg={11}>
              <Outlet />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <CustomModal
        open={!!openPromotion}
        onClose={() => setOpenPromotion(null)}
        children={
          <Stack spacing={4} sx={{ p: 2 }}>
            <Box sx={{ width: '100%', textAlign: 'center' }}>
              <Typography className="gold-text" variant="h4" fontWeight={900}>
                {openPromotion?.title}
              </Typography>
            </Box>

            <Box sx={{ width: '100%' }}>
              {openPromotion?.description && isHTML(openPromotion?.description) ? (
                <Box
                  sx={{
                    '& ol, ul': { listStylePosition: 'inside', overflow: 'hidden' },
                    '& li p': { display: 'inline' },
                  }}
                  dangerouslySetInnerHTML={sanitizeHtml(openPromotion?.description)}
                />
              ) : (
                <Typography>{openPromotion?.description || ''}</Typography>
              )}
            </Box>
          </Stack>
        }
      />

      <PopupBanner />
    </Page>
  );
};

export default HomeLayout;
